import { Http } from './../helpers'
export const MemberService = {
  async search(params) {
    return Http.get('/members', { params: params })
  },
  async view(id) {
    return Http.get('/members/' + id)
  },
  async add(data) {
    return Http.post('/members', data)
  },
  async update(id, data) {
    return Http.put('/members/' + id, data)
  },
  async setMemberStatus(id, status) {
    return Http.put('/members/' + id + '/status', { status: status })
  },
  async setNewPasswoord(id, params) {
    return Http.put('/members/' + id + '/reset-pwd', params)
  },
  async getStatusItems() {
    return Http.get('/members/status')
  },
}
